import { Dispatch } from 'redux';
import { getTaxRules } from 'app/shared/api/taxRules/getTaxRules';
import type { TaxRuleListRow } from 'app/shared/api/taxRules/types';

export const FETCH_TAX_RULES = 'TAX_MANAGER/FETCH_TAX_RULES';
export const SET_TAX_RULES = 'TAX_MANAGER/SET_TAX_RULES';
export const TAX_SET_FILTER_NAME = 'TAX_MANAGER/SET_FILTER_NAME';
export const TAX_SET_FILTER_CENTRE = 'TAX_MANAGER/SET_FILTER_CENTRE';
export const TAX_SET_FILTER_COUNTRY = 'TAX_MANAGER/SET_FILTER_COUNTRY';
export const TAX_SET_FILTER_SPECIFIC_CENTRE = 'TAX_MANAGER/SET_FILTER_SPECIFIC_CENTRE';
export const TAX_SET_FILTER_START_FROM = 'TAX_MANAGER/SET_FILTER_START_FROM';

export type TaxFilterCentre = {
  id: number | string;
  countryId?: number;
  countryCode?: string;
} | null;

export type TaxFilterCountry = {
  countryId?: number;
  countryCode?: string;
} | null;

export const setTaxRules = (items: TaxRuleListRow[]) => ({
  type: SET_TAX_RULES,
  payload: items,
});

export const setFilterName = (value: string) => ({
  type: TAX_SET_FILTER_NAME,
  payload: value,
});

export const setFilterCentre = (value: TaxFilterCentre) => ({
  type: TAX_SET_FILTER_CENTRE,
  payload: value,
});

export const setFilterCountry = (value: TaxFilterCountry) => ({
  type: TAX_SET_FILTER_COUNTRY,
  payload: value,
});

export const setFilterSpecificCentre = (value: boolean) => ({
  type: TAX_SET_FILTER_SPECIFIC_CENTRE,
  payload: value,
});

export const setFilterStartDateFrom = (value: string | null) => ({
  type: TAX_SET_FILTER_START_FROM,
  payload: value,
});

export const fetchTaxRules = () => async (dispatch: Dispatch) => {
  dispatch({ type: FETCH_TAX_RULES });
  try {
    const data = await getTaxRules();
    dispatch(setTaxRules(Array.isArray(data) ? data : []));
  } catch {
    dispatch(setTaxRules([]));
  }
};